import React from 'react';
import propTypes from 'prop-types';

import FullScreenContainer from '../FullScreenContainer';
import styled, { css } from 'styled-components';

const backgroundPartial = css`
    background: white;
    background: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.3) 40%,
            rgba(147, 147, 147, 0.3) 100%
        ),
        rgba(255, 255, 255, 0.9);
`;

const ContainerDiv = styled.div`
    width: 30%;
    min-width: 30rem;
    margin: 0 auto;
    padding: 1.5rem;
    ${backgroundPartial}
    border-radius: 10px;
    box-shadow: 0 0.874rem 2.5rem 0 rgba(0, 0, 0, 0.2);
`;

function Modal(props) {
    const { children, style } = props;

    return (
        <FullScreenContainer>
            <ContainerDiv style={style}>{children}</ContainerDiv>
        </FullScreenContainer>
    );
}

Modal.propTypes = {
    children: propTypes.node,
    style: propTypes.object,
};

export default Modal;
